<script>
    // import { createEventDispatcher } from 'svelte';
    import { tick, beforeUpdate } from "svelte";
    import Message from "../routes/components/message.svelte";

    let dataTable;
    let tableElement;
    // const dispatch = createEventDispatcher();

    export let message;
    export let DataLength = 0;
    export let bAutoWidth = false;
    export let paging = false;
    export let pageLength = 50;
    export let info = true;
    // export let responsive = true;
    export let lengthChange = false;
    export let dom = 'lfBrtip';
     export let buttons = [{extend:"csvHtml5",text:'<span class="material-icons">vertical_align_bottom</span>Export',className:"btn-light"}];
    //export let buttons = [{extend:"",text:'',className:""}];
    export let columnDefs = [];
    export let order = [[0, "asc"]];
    export let searching = true;
    export let noSort = false;
    export let isFixedHeight = false;
    export let ResponsiveHeader = '0';
    export let data = [];
    export let tableCSS = "table";
    export let columns = [];
    let fixedHeight="";
    if(isFixedHeight)
        fixedHeight = (0.6*window.innerHeight);

    if(noSort)
        order =[];

    export let config = {
        bAutoWidth: bAutoWidth,
        paging: paging,
        pageLength: pageLength,
        info: info,
        searching: searching,
        lengthChange: lengthChange,
        dom: dom,
        // stateSave: true,
        buttons: buttons,
        language: {
            search:"",
            info: " Showing _END_ of _TOTAL_ ",
            emptyTable: "<div class='spinner-border text-secondary' role='status'><span class='sr-only'>Loading...</span></div>",
        },
        columnDefs: columnDefs,
        ...data.length > 0 && { data: data },
        ...columns.length > 0 && { columns: columns },
        order: order,
        sScrollY:fixedHeight,
        responsive: {
            details: {
                display: jQuery.fn.dataTable.Responsive.display.modal( {
                    header: function ( row ) {
                        var data = row.data();
                        if (ResponsiveHeader.includes(',')){
                            var arr = ResponsiveHeader.split(',');
                            var value = "";
                            jQuery.each(arr, function(index, item) {
                                value += data[item] + ' ';
                            });
                            return 'Details for '+ value;
                        }
                        else
                        {
                            return 'Details for '+ data[ResponsiveHeader];
                        }
                    }
                } ),
                renderer: function ( api, rowIdx, columns ) {
                    var data = jQuery.map( columns, function ( col, i ) {
                        var tablerow = '';

                        if (col.data.includes("d-block d-sm-none")){
                            tablerow = '';
                        }
                        else if (col.data.includes("text-danger")){
                            tablerow = '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' + '<td>' + col.title + '</td> ' + '<td class="text-danger">' + dataTable.cell(rowIdx, i).render('display') + '</td>' + '</tr>' ;
                        }
                        else
                        {
                            tablerow = '<tr data-dt-row="' + col.rowIndex + '" data-dt-column="' + col.columnIndex + '">' + '<td>' + col.title + '</td> ' + '<td>' + dataTable.cell(rowIdx, i).render('display') + '</td>' + '</tr>' ;
                        }
                        return tablerow;
                    }).join('');
                    return data ? jQuery('<table class="table table-striped" />').append( data ) : false;
                }
            }
        },
         //"fnDrawCallback" : function(oSettings) {
             //dispatch('message', {text: 'TableUpdated'});
         //}
         deferRender: true,
    };

    export const search = (searchTerm) => {
        dataTable.search(searchTerm).draw();
    };

    export const adjust =()=>{
        if(isFixedHeight && dataTable)      
             dataTable.columns.adjust().draw();
    }

    const buildTable = () => {

        if (dataTable != null) return;

        if (data.length > 0)
        {
            // to load 'data' again if it has changed.
            var dtConfig = Object.assign({}, config);
            dtConfig.data = data;
            
            dataTable = jQuery(tableElement).DataTable(dtConfig);
        }
        else
            dataTable = jQuery(tableElement).DataTable(config);
        
        //jQuery(dataTable.table().container()).removeClass("form-inline");

        var cl = jQuery(dataTable.table().container()).find(".col-md-6:eq(0)");
        var cl2 = jQuery(dataTable.table().container()).find(".col-md-6:eq(1)");    
        var searchbox = jQuery(dataTable.table().container()).find(".dataTables_filter input");
        cl2.addClass("text-right");     
        searchbox.removeClass("form-control-sm");
        searchbox.css("width","300px");
        dataTable.buttons().container().appendTo(cl2);
        jQuery(dataTable.table().container())
            .find(".dataTables_filter")
            .appendTo(cl);
        var info = dataTable.page.info();
        var tot = info.recordsTotal;
        if (tot == 0) {
            jQuery(dataTable.table().container()).find(".dt-buttons").remove();
            jQuery(dataTable.table().container())
                .find(".dataTables_info")
                .remove();
            jQuery(dataTable.table().container())
                .find(".dataTables_filter")
                .remove();
        }

        if(!searching)
        dataTable.buttons('.btn-light').remove();

        // page change event
        //dataTable.on('page.dt', function(e, setting){
            // var pageInfo = dataTable.page.info();
            // if (pageInfo.page == (pageInfo.pages - 1))
            //     dispatch('pageChange');
        //});


        //  dataTable.buttons().disable();   
        
        // jQuery(window).on('resize', function () {
        //     dataTable.fnAdjustColumnSizing();
        // } );

        resizeObserver.observe(document.querySelector('#page-content-wrapper'));
    };
    
    const resizeObserver = new ResizeObserver(() => {
        var table = jQuery.fn.dataTable.fnTables(true);
            if ( table.length > 0 ) {
                jQuery(table).dataTable().fnAdjustColumnSizing();
            }
    });

    beforeUpdate(async () => {      
        
        if (!tableElement) return;

        if (dataTable) {
            dataTable.destroy();
            dataTable = null;
        }
        await tick();
        //setTimeout(buildTable,1)
        buildTable();        
    });

</script>



{#if DataLength > 0}
    <div class="{tableCSS}">
        <table
            bind:this={tableElement}
            class="table table-striped table-hover sticky-header"
            cellspacing="0"
            border="0"
            style="border-collapse:collapse;width:100%">
            <slot />
        </table>
    </div>
{:else}
    <Message {message}></Message>
{/if}
